export default function unsetGrabCursor() {
  const swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}


//////////////////
// WEBPACK FOOTER
// /Users/jpaq/Local Sites/metsfarsa/app/public/wp-content/themes/farsa/node_modules/swiper/core/grab-cursor/unsetGrabCursor.js
// module id = 59
// module chunks = 0